import EditTeamContainer from "../containers/EditTeamContainer";

const EditTeamPage = () => {
  return (
    <EditTeamContainer />
  );
};

export default EditTeamPage;
